import { Dispatch, SetStateAction } from 'react';
import Modal from '../Modal';
import CheckSuccess from '../Icons/CheckSuccess';

type Dictionary = {
  title: string;
  description: string;
};

type Props = {
  dict: Dictionary;
  modalIsOpen: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function WorkWithUsModalSuccess({
  dict,
  modalIsOpen,
  setModalIsOpen,
}: Props) {
  return (
    <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
      <Modal.Content contentCustomClass="" onOpenChange={setModalIsOpen}>
        <div className="py-[30px] px-[20px]">
          <div className="text-center">
            <div className="relative w-14 h-14 mb-4 mx-auto">
              <CheckSuccess />
            </div>
            <h3 className="mb-5 text-success text-medium font-averta-semibold">
              {dict.title}
            </h3>
            <p className="text-base">{dict.description}</p>
          </div>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
